import { Provider } from "@angular/core";
import { Environment } from "../models/environment.model";
import { EnvironmentService } from "../services/environment.service";

export function provideEnvironment(environment?: Environment): Provider {
  return {
    provide: EnvironmentService,
    multi: false,
    useFactory: () => new EnvironmentService(environment),
  };
}